/* eslint-disable @typescript-eslint/no-unused-expressions */
import Cookies from 'js-cookie';

export const cookiesStorage = {
  getCookie: (name: string) => {
    return Cookies.get(name);
  },
  setCookie: (name: string, value: string, expiry: number) => {
    Cookies.set(name, value, { expires: expiry });
  },
  clearCookie: (name: string) => {
    Cookies.remove(name);
  },
  getCookieDetails: async (name: string) => {
    let details;
    if (window !== undefined) details = await window.cookieStore.get(name);
    return details;
  },
};

export const localStorage = {
  getToken: (name: string) => {
    if (window !== undefined) return window.localStorage.getItem(name);
    return null;
  },
  setToken: (name: string, value: string) => {
    window !== undefined && window.localStorage.setItem(name, value);
  },
  clearToken: (name: string) => {
    window !== undefined && window.localStorage.removeItem(name);
  },
};
